import React from "react";
import { Dropdown } from "antd";
import styles from "./SortingSelector.module.css";
import styled from "@emotion/styled";

const SortingSelector = ({ options, selected, handleChange }) => {
  const onClick = ({ key }) => {
    handleChange([key]);
  };

  const CustomDropdown = styled(Dropdown)`
    && .ant-dropdown-menu-item-selected {
      background: transparent !important;
    }
  `;

  return (
    <div className={styles.picker_wrap}>
      Show:
      <CustomDropdown
        className={styles.dowpdown_wrap}
        menu={{
          items: options,
          selectable: true,
          defaultSelectedKeys: selected,
          onClick,
          className: `${styles.drop_menu} duraion-picker`,
        }}
      >
        <div className={styles.selected_option}>{selected?.[0]}</div>
      </CustomDropdown>
    </div>
  );
};

export default SortingSelector;
